import React, { useEffect, useRef } from "react";
import "./Listersociete.css";
import MUIDataTable from "mui-datatables";
import { CircularProgress, IconButton } from "@material-ui/core";
import { Box, TextField } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { useState } from "react";
import { getUserData, getRowData } from "../../utils/FunctionHelpers";
import { deleteSociete } from "../Services/SocieteService";
import DialogDeleteCustom from "../../components/DialogDeleteCustom/DialogDeleteCustom";
import { Delete } from "@material-ui/icons";
import { withSnackbar } from "../../utils/SnackbarHOC";
import { handleOnViewColumnsChange, displayColumn } from "../../utils/viewColumns";
import { handleChangeRowsPerPage, getRowsPerPage } from "../../utils/DataTables";
import moment from "moment";

const ListerSociete = ({
  societesData,
  handleSearchSocietes,
  parameters,
  snackbarShowMessage
}) => {
  const history = useHistory();
  const mounted = useRef(false);
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [loadToDelete, setLoadToDelete] = useState(false)
  const [societeSelectedToDelete, setSocieteSelectedToDelete] = useState(null)
  const sortingRef = useRef(false);

  const handlePageChange = (pageIndex, tableState) => {
    handleSearchSocietes(pageIndex + 1, {
      ...parameters,
      column: tableState.sortOrder?.name,
      sort: tableState.sortOrder?.direction,
      search: tableState.searchText || "",
    }, tableState.rowsPerPage);
  };
  const handleCloseDialog = () => {
    if (loadToDelete) {
      return;
    }
    setOpenDialogDelete(false);
  };

  const handleOpenDialog = (societe) => {
    setSocieteSelectedToDelete({ id: societe.id, name: societe.name.charAt(0).toUpperCase() + societe.name.slice(1) });
    setOpenDialogDelete(true);
  }

  const dialogDeleteProps = {
    handleClose: handleCloseDialog,
    handleOpen: openDialogDelete,
    loading: loadToDelete,
    title: "Supprimer la societe"
  }

  const handleDeleteSociete = async (uuid) => {
    try {
      setLoadToDelete(true);
      snackbarShowMessage("Patientez svp...", "warning", null);
      const { data } = await deleteSociete(uuid)
      handleSearchSocietes(societesData.pageSociete, parameters);
      snackbarShowMessage(data);
    } catch (error) {
      snackbarShowMessage("Erreur à la suppression de la societe", "error", 4000);
    } finally {
      setLoadToDelete(false);
      setOpenDialogDelete(false);
    }
  };

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  const tableName = "societeColumnVisibility";

  const columns = [
    {
      name: "updatedAt",
      label: "DATE MAJ",
      options: {
        display: displayColumn("updatedAt", tableName),
        filter: true,
        sort: true,
        sortDirection: (societesData.sorting?.name || societesData.sorting?.column) === 'updatedAt' ? societesData.sorting?.direction : undefined,
        setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } }),
        customBodyRender: (value) => {
          return <> {value ? moment(value).format("DD/MM/yyyy") : "-"} </>;
        },
      },
    },
    {
      name: "uuid",
      label: "N° SOCIETE",
      options: {
        display: false,
        setCellProps: () => ({ style: { whiteSpace: "nowrap", textOverFlow: "ellipsis", overflow: "hidden", maxWidth: "100px" } }),
      },
    },
    {
      name: "nomSociete",
      label: "NOM SOCIETE",
      options: {
        display: displayColumn("nom_societe", tableName),
        sort: true,
        sortDirection: (societesData.sorting?.name || societesData.sorting?.column) === 'nom_societe' ? societesData.sorting?.direction : undefined,
        setCellHeaderProps: () => ({ style: { justifyContent: "left" } }),
        customBodyRender: (value, tableMeta) => {
          const row = getRowData(tableMeta, columns);
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "250px", textAlign: "left", marginLeft: "9%" }}>
                <Link to={{
                  pathname: `/societe/${row.uuid}/view`,
                  state: { uuid: row.uuid },
                }} >
                  {value}
                </Link>
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "statut",
      label: "STATUT",
      options: {
        display: displayColumn("statut", tableName),
        sort: true,
        sortDirection: (societesData.sorting?.name || societesData.sorting?.column) === 'statut' ? societesData.sorting?.direction : undefined,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px", textAlign: "left", textTransform: "capitalize" }}>
                {value ? value : "-"}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "typeSociete",
      label: "TYPE",
      options: {
        display: displayColumn("typeSociete", tableName),
        sort: true,
        sortDirection: (societesData.sorting?.name || societesData.sorting?.column) === 'typeSociete' ? societesData.sorting?.direction : undefined,
        customBodyRender: (value, tableMeta, updateValue) => {
          const typeValue = value || "-";
          return (
            <Box
              data-toggle="tooltip"
              title={typeValue}
              style={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                width: "150px",
                textAlign: "left",
              }}
            >
              {typeValue}
            </Box>
          );
        },
      },
    },
    {
      name: "secteurActivite",
      label: "SECTEUR D'ACTIVITÉ",
      options: {
        display: displayColumn("secteur_dactivite", tableName),
        sort: true,
        sortDirection: (societesData.sorting?.name || societesData.sorting?.column) === 'secteur_dactivite' ? societesData.sorting?.direction : undefined,
        customBodyRender: (value, tableMeta, updateValue) => {
          const secteur = value || "-";
          return (
            <>
              <Box data-toggle="tooltip"
                title={secteur}
                style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "150px", textAlign: "left" }}>
                {secteur}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "siteinternet",
      label: "INTERNET",
      options: {
        display: displayColumn("siteinternet", tableName),
        sort: true,
        sortDirection: (societesData.sorting?.name || societesData.sorting?.column) === 'siteinternet' ? societesData.sorting?.direction : undefined,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px", textAlign: "left" }}>
                {value ? (
                  <a href={value} target="_blank" rel="noreferrer">
                    {value}
                  </a>
                ) : (
                  "-"
                )}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "localisation",
      label: "LOCALISATION",
      options: {
        display: displayColumn("localisation", tableName),
        sort: true,
        sortDirection: (societesData.sorting?.name || societesData.sorting?.column) === 'localisation' ? societesData.sorting?.direction : undefined,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "150px", textAlign: "left", textTransform: "capitalize" }}>
                {value ? value : "-"}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "contacts",
      label: "Nb CONTACTS",
      options: {
        display: displayColumn("contacts", tableName),
        sort: true,
        sortDirection: (societesData.sorting?.name || societesData.sorting?.column) === 'contacts' ? societesData.sorting?.direction : undefined,
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <Link
              to={{ pathname: `/societe/${row.uuid}/view?tab=2` }}
              onClick={(event) => {
                event.preventDefault();
                history.push(`/societe/${row.uuid}/view?tab=2`);
              }}
              aria-haspopup="true"
              data-toggle="tooltip"
              style={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                width: "80%",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Box data-toggle="tooltip" title={value} style={{ width: "100px", textAlign: "left" }}>{value}</Box>
            </Link>
          );
        },
      },
    },
    {
      name: "missions",
      label: "MISSIONS",
      options: {
        display: displayColumn("missions", tableName),
        sort: true,
        sortDirection: (societesData.sorting?.name || societesData.sorting?.column) === 'missions' ? societesData.sorting?.direction : undefined,
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <Link
              to={{ pathname: `/societe/${row.uuid}/view?tab=1` }}
              onClick={(event) => {
                event.preventDefault();
                history.push(`/societe/${row.uuid}/view?tab=1`);
              }}
              aria-haspopup="true"
              data-toggle="tooltip"
              style={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                width: "80%",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Box data-toggle="tooltip" title={value} style={{ width: "100px", textAlign: "left" }}>{value}</Box>
            </Link>
          );
        },
      },
    },
    {
      name: "createdAt",
      label: "DATE CRÉATION",
      options: {
        display: displayColumn("createdAt", tableName),
        filter: true,
        sort: true,        sortDirection: (societesData.sorting?.name || societesData.sorting?.column) === 'createdAt' ? societesData.sorting?.direction : undefined,        setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } }),
        customBodyRender: (value) => {
          return <> {value ? moment(value).format("DD/MM/yyyy") : "-"} </>;
        },
      },
    },
    {
      name: "",
      label: "ACTION",
      options: {
        filter: false,
        sort: false,
        display: getUserData()?.role.includes("ROLE_ADMIN"),
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverFlow: "ellipsis",
            overflow: "hidden",
            maxWidth: "100px",
            textTransform: "capitalize",
          },
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <IconButton
              data-toggle="tooltip"
              title="Supprimer"
              aria-label="Supprimer"
              onClick={
                () => handleOpenDialog({ id: row.uuid, name: `${row.nom_societe}` })
              }
              style={{ color: "#EF6262" }}
            >
              <Delete />
            </IconButton>
          );
        },
      },
    }
  ];



  const options = {
    rowsPerPageOptions: [30, 50, 75, 100],
    jumpToPage: true,
    page: societesData.pageSociete - 1,
    serverSide: true,
    tableBodyMaxHeight: "none",
    count: societesData.societesCount,
    rowsPerPage: getRowsPerPage(tableName) ?? societesData.limit,
    textLabels: {
      body: {
        noMatch: societesData.isLoading ? <CircularProgress /> : "Désolé, il n'y a aucun enregistrement dans la base de données pour le moment.",
      },
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changeRowsPerPage":
          handleChangeRowsPerPage(tableName, tableState.rowsPerPage);
          handleSearchSocietes(1, parameters, tableState.rowsPerPage);
          break;
        case "changePage":
          if (sortingRef.current) {
            sortingRef.current = false;
            break;
          }
          handlePageChange(tableState.page, tableState);
          break;
        case "sort":
          sortingRef.current = true;
          const { name: columnName, direction: sortDir } = tableState.sortOrder;
          handleSearchSocietes(1, {
            ...parameters,
            column: columnName,
            sort: sortDir,
          });
          break;
        case "search":
          handleSearchSocietes(1, {
            ...parameters,
            column: tableState.sortOrder?.name,
            sort: tableState.sortOrder?.direction,
            search: tableState.searchText || "",
          }, tableState.rowsPerPage);
          break;
        default:
      }
    },
    sortOrder: {
      name: societesData.sorting?.name || societesData.sorting?.column || '',
      direction: societesData.sorting?.direction || 'asc'
    },

    customSearchRender: (searchText, handleSearch, hideSearch, options) => {
      const handleKeyDown = (event) => {
        if (event.key === "Enter") {
          handleSearch(event.target.value);
        }
      };

      return (
        <TextField
          variant="standard"
          placeholder="Search"
          defaultValue={searchText}
          onKeyDown={handleKeyDown}
          // onBlur={hideSearch}
          fullWidth
          autoFocus
        />
      );
    },
    onViewColumnsChange: (columnName, action) => {
      handleOnViewColumnsChange(columnName, action, tableName);
    },
    selectableRows: "none",
    draggableColumns: {
      enabled: true,
    },
    filter: true,
    filterType: "dropdown",
    responsive: "standard",

  };

  return (
    <>
      <div className="candidatTableWrapper" style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
      <MUIDataTable data={societesData.societes} title="Sociétés" columns={columns} options={options} />
      <DialogDeleteCustom {...dialogDeleteProps} handleDelete={() => handleDeleteSociete(societeSelectedToDelete?.id)} label={`Voulez - vous vraiment supprimer la societe ${societeSelectedToDelete?.name} ?`} />
      </div>
    </>
  );
};
export default withSnackbar(ListerSociete);
